
import { Component, Vue } from 'vue-property-decorator';
import LoginForm from '@/components/login/LoginForm.vue';
import { LoginFormData } from '@/model/Authentication';
import { mapActions, mapGetters } from 'vuex';
import Selector from '@/components/language/Selector.vue';
import CustomOverlay from '@/components/overlay/custom-overlay.vue';

@Component({
    components: {
        LoginForm,
        Selector,
        CustomOverlay,
    },
    methods: {
        ...mapActions({
            login: 'authenticationStorage/login',
        }),
    },
    computed: {
        ...mapGetters({
            loginError: 'authenticationStorage/getError',
        }),
    },
})
export default class Login extends Vue {
    loading = false;

    login!: (formData: LoginFormData) => Promise<void>;

    mounted(): void {
        this.$store.commit('authenticationStorage/setError', null);
    }

    onSubmit(formData: LoginFormData): void {
        this.loading = true;

        this.login(formData)
            .then(() => {
                this.$router.push({ name: 'Dashboard' });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
